module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab3",
      "name": "hres31x-tab3"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-users icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['300']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteempmt'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codcomp']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codpos']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codbrlc']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codempmt']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['typpayroll']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['typemp']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codcalen']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codjob']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['280']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['jobgrad']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['290']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['codgrpgl']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['300']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteefstep'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['qtydtepr']) + " " + _vm._s(_vm.labels['HRES31XC3']['150']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['qtyyear']) + " " + _vm._s(_vm.labels['HRES31XC3']['170']) + "\n        " + _vm._s(_vm.detail['qtymonth']) + " " + _vm._s(_vm.labels['HRES31XC3']['180']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['email']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numlvl']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteeffex'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteeflvl'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['210']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteoccup'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numreqst']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['staemp']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['flgatten']))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail['dteefpos'])))])]), _vm._v(" "), _c('div', {
    staticClass: "row data-box"
  }, [_c('div', {
    staticClass: "col-xs-6 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC3']['260']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 data-text"
  }, [_vm._v(_vm._s(_vm.detail['numtelof']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7209167c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab3.vue
// module id = 3863
// module chunks = 1